import { Button, useDisclosure } from "@chakra-ui/react";
import { TransactionEvent } from "@syla/shared/types/responses/TransactionEvent";
import React from "react";
import { HiOutlineDatabase } from "react-icons/hi";
import { SourceDataViewerModal } from "./SourceDataViewerModal";

export function SourceDataButton({
  transaction,
}: {
  transaction: TransactionEvent;
}): React.ReactElement | null {
  const sourceDataDisclosure = useDisclosure();

  if (!transaction.sourceData?.length) {
    return null;
  }

  return (
    <>
      <Button
        variant="outline"
        colorScheme="gray"
        leftIcon={<HiOutlineDatabase />}
        onClick={sourceDataDisclosure.onOpen}
      >
        Source data
      </Button>
      <SourceDataViewerModal
        disclosure={sourceDataDisclosure}
        sourceData={transaction.sourceData.map((sourceData) => sourceData.data)}
      />
    </>
  );
}
